import React from "react";

import { SwitchInputStyled, SwitchInputStyledWrapper } from "./styled";

const SwitchInput = ({ id, checked, onChange, labelText, ...props }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // simulate checkbox toggle
      onChange({
        target: {
          checked: !checked
        }
      });
    }
  };

  return (
    <SwitchInputStyledWrapper>
      <SwitchInputStyled
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        {...props}
      />
      <label htmlFor={id}>{labelText}</label>
    </SwitchInputStyledWrapper>
  );
};

export default SwitchInput;
